const clientState = {
    version: '1.0',
    type: 'enum',
    ClientState: {
      values: [
        'Active', 'Inactive'
      ]
    }
  };
  
  export default clientState; 